module.exports = __webpack_public_path__ + "img/new_1.6507d3d6.png";